import { HTMLFromRichText, PrismicLink, PrismicSharpImage, TextFromRichText } from '../PrismicTypes';

export const CATEGORY_HERO_IMAGE = 'PrismicGenericTemplateDataBodyCategoryPageHero';

export const GENERIC_HERO_BUTTON = 'button';

export interface CategoryHeroImagePrimary {
  hero_component_image?: PrismicSharpImage;
  hero_image_subtitle: HTMLFromRichText;
  hero_image_title: TextFromRichText;
  hero_image_variant: 'light' | 'dark';
  primary_button: TextFromRichText;
  primary_button_link: PrismicLink;
  secondary_button: TextFromRichText;
  secondary_button_link: PrismicLink;
}

export interface CategoryHeroImageContent {
  __typename: typeof CATEGORY_HERO_IMAGE;
  primary: CategoryHeroImagePrimary;
}
